// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"97db913d","498":"6077ed4a","703":"5e094d68"}[chunkId] + ".chunk.js";
};